<template>
  <CSidebar 
    fixed 
    :minimize="minimize"
    :show="show"
    @update:show="(value) => $store.commit('set', ['sidebarShow', value])"
  >
    <CSidebarBrand class="d-md-down-none" to="/">
     <h3>AGENT PANEL</h3>
    </CSidebarBrand>
    <CSidebarBrand>
     <div class="d-block">Hello, <strong>{{user}}</strong> <span v-if="account!=''">[{{account}}]</span> <br />
     <strong>Your Balance:</strong> ${{balance}}</div>
    </CSidebarBrand>
    <CRenderFunction flat :content-to-render="$options.nav"/>

    <CSidebarMinimizer
      class="d-md-down-none"
      @click.native="$store.commit('set', ['sidebarMinimize', !minimize])"
    />
  </CSidebar>
</template>

<script>
import nav from './_nav'

export default {
  name: 'TheSidebar',
  nav,
  data () {
    return {
       user: 'User',
       account: '',
       userid: false,
       balance: 0.00
    }
  },
   methods: {
   loadProfile(){
     let self = this;
        this.$api
        .get('profile')
        .then(function (responce){
          self.user = responce.data.user.name;
          self.account = responce.data.user.account.name;
          self.userid = responce.data.user.id;
        });
      }
    },
  computed: {
    show () {
      return this.$store.state.sidebarShow 
    },
    minimize () {
      return this.$store.state.sidebarMinimize 
    }
  },
  mounted: function () {
     this.loadProfile();
  }
}
</script>
